import React from 'react';
import Callback from 'src/screens/ConnectsCallback/Callback';
import { useConnectHook } from '../hooks';

const Xero = () => {
  const {
    connectState
  } = useConnectHook('xero');
  return (
    <Callback result={connectState} />
  )
}

export default Xero;
